import CodeQuoteTypeList from "./pages/ListPage.vue";
import CodeQuoteTypeDetail from "./pages/FormPage.vue";
import CodeQuoteTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_quote_type",
    component: CodeQuoteTypeIndex,
    redirect: "/code_quote_type/list",
    name: "code_quote_type",
    children: [
      {
        path: "list",
        component: CodeQuoteTypeList,
        name: "code_quote_type.list",
      },
      {
        path: "create",
        component: CodeQuoteTypeDetail,
        name: "code_quote_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeQuoteTypeDetail,
        name: "code_quote_type.edit",
        props: { create: false },
      },
    ],
  },
];
